import React from 'react';

import FlipCard from '@swf/components/FlipCard/FlipCard';

import type { CardConfig, CardViewProps } from '../../config/NotificationTypes';

import styles from './Main.scss';

enum CardSide {
  FRONT = 'front',
  BACK = 'back'
}
interface CardTemplateProps extends CardConfig {
  cardSide: CardSide;
}

const CardTemplate: React.FC<CardTemplateProps> = (props) => {
  const {
    cardData,
    onToggleFlip,
    onClickClose,
    onClickPrimaryAction,
    onClickSecondaryAction,
    onClickC2L,
    locale,
    license,
    cardSide
  } = props;

  const ConfiguredView = props[cardSide].view;
  const { viewConfig } = props[cardSide];

  const cardViewProps: CardViewProps = {
    viewConfig,
    cardData,
    onClickClose,
    onToggleFlip,
    onClickPrimaryAction,
    onClickSecondaryAction,
    onClickC2L,
    locale,
    license
  };

  return <ConfiguredView {...cardViewProps} />;
};

const Notification: React.FC<CardConfig> = (props) => {
  const { back, showBack } = props;
  const frontProps = { ...props, cardSide: CardSide.FRONT };
  const backProps = { ...props, cardSide: CardSide.BACK };
  return (
    <section className={styles.container}>
      <FlipCard flipped={showBack}>
        <CardTemplate {...frontProps} />
        {back && <CardTemplate {...backProps} />}
      </FlipCard>
    </section>
  );
};

export default Notification;
